/**
 * Ensure all parent categories in a path are expanded, collapsing all others
 * @param {string|array} path - The path to expand
 * @param {Function} setExpandedCategories - The state setter for expandedCategories
 */
export const expandCategoryPath = (path, setExpandedCategories) => {
  if (!path) return

  const newExpandedCategories = {}
  const pathSegments = typeof path === "string" ? path.split("/") : path

  let currentPath = ""
  for (const segment of pathSegments) {
    if (segment) {
      currentPath = currentPath === "" ? segment : `${currentPath}/${segment}`
      if (currentPath) {
        newExpandedCategories[currentPath] = true
      }
    }
  }

  setExpandedCategories(newExpandedCategories)
}
